(function () {
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}



"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.state = initialState || this.getEmptyBoard();
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "getEmptyBoard",
            value: function getEmptyBoard() {
                return Array(4).fill(null).map(function() {
                    return Array(4).fill(0);
                });
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.state.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                if (this.status === "idle") {
                    this.status = "playing";
                    this.addRandomTile();
                    this.addRandomTile();
                }
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.state = this.getEmptyBoard();
                this.score = 0;
                this.status = "idle";
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = [];
                this.state.forEach(function(row, y) {
                    row.forEach(function(cell, x) {
                        if (cell === 0) emptyCells.push({
                            y: y,
                            x: x
                        });
                    });
                });
                if (emptyCells.length > 0) {
                    var _emptyCells_Math_floor = emptyCells[Math.floor(Math.random() * emptyCells.length)], y = _emptyCells_Math_floor.y, x = _emptyCells_Math_floor.x;
                    this.state[y][x] = Math.random() < 0.9 ? 2 : 4;
                }
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this;
                if (this.status !== "playing") return false;
                var moved = false;
                var newState = this.state.map(function(row) {
                    var nonZero = row.filter(function(cell) {
                        return cell !== 0;
                    });
                    for(var i = 0; i < nonZero.length - 1; i++)if (nonZero[i] === nonZero[i + 1]) {
                        nonZero[i] *= 2;
                        _this.score += nonZero[i];
                        nonZero[i + 1] = 0;
                    }
                    nonZero = nonZero.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(nonZero.length < 4)nonZero.push(0);
                    return nonZero;
                });
                var hasChanged = JSON.stringify(this.state) !== JSON.stringify(newState);
                if (hasChanged) {
                    this.state = newState;
                    this.addRandomTile();
                    moved = true;
                }
                this.checkGameStatus();
                return moved;
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this;
                if (this.status !== "playing") return false;
                var moved = false;
                var newState = this.state.map(function(row) {
                    var nonZero = row.filter(function(cell) {
                        return cell !== 0;
                    }).reverse();
                    for(var i = 0; i < nonZero.length - 1; i++)if (nonZero[i] === nonZero[i + 1]) {
                        nonZero[i] *= 2;
                        _this.score += nonZero[i];
                        nonZero[i + 1] = 0;
                    }
                    nonZero = nonZero.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(nonZero.length < 4)nonZero.push(0);
                    return nonZero.reverse();
                });
                var hasChanged = JSON.stringify(this.state) !== JSON.stringify(newState);
                if (hasChanged) {
                    this.state = newState;
                    this.addRandomTile();
                    moved = true;
                }
                this.checkGameStatus();
                return moved;
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this, _loop = function(col) {
                    var column = [];
                    for(var row = 0; row < 4; row++)if (_this.state[row][col] !== 0) column.push(_this.state[row][col]);
                    for(var i = 0; i < column.length - 1; i++)if (column[i] === column[i + 1]) {
                        column[i] *= 2;
                        _this.score += column[i];
                        column[i + 1] = 0;
                    }
                    column = column.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(column.length < 4)column.push(0);
                    for(var row1 = 0; row1 < 4; row1++)newState[row1][col] = column[row1];
                };
                if (this.status !== "playing") return false;
                var moved = false;
                var newState = this.getEmptyBoard();
                for(var col = 0; col < 4; col++)_loop(col);
                var hasChanged = JSON.stringify(this.state) !== JSON.stringify(newState);
                if (hasChanged) {
                    this.state = newState;
                    this.addRandomTile();
                    moved = true;
                }
                this.checkGameStatus();
                return moved;
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this, _loop = function(col) {
                    var column = [];
                    for(var row = 3; row >= 0; row--)if (_this.state[row][col] !== 0) column.push(_this.state[row][col]);
                    for(var i = 0; i < column.length - 1; i++)if (column[i] === column[i + 1]) {
                        column[i] *= 2;
                        _this.score += column[i];
                        column[i + 1] = 0;
                    }
                    column = column.filter(function(cell) {
                        return cell !== 0;
                    });
                    while(column.length < 4)column.push(0);
                    for(var row1 = 0; row1 < 4; row1++)newState[3 - row1][col] = column[row1];
                };
                if (this.status !== "playing") return false;
                var moved = false;
                var newState = this.getEmptyBoard();
                for(var col = 0; col < 4; col++)_loop(col);
                var hasChanged = JSON.stringify(this.state) !== JSON.stringify(newState);
                if (hasChanged) {
                    this.state = newState;
                    this.addRandomTile();
                    moved = true;
                }
                this.checkGameStatus();
                return moved;
            }
        },
        {
            key: "checkGameStatus",
            value: function checkGameStatus() {
                if (this.state.some(function(row) {
                    return row.includes(2048);
                })) {
                    this.status = "win";
                    return;
                }
                if (!this.hasAvailableMoves()) this.status = "lose";
            }
        },
        {
            key: "hasAvailableMoves",
            value: function hasAvailableMoves() {
                if (this.state.some(function(row) {
                    return row.includes(0);
                })) return true;
                for(var y = 0; y < 4; y++)for(var x = 0; x < 3; x++){
                    if (this.state[y][x] === this.state[y][x + 1]) return true;
                }
                for(var x1 = 0; x1 < 4; x1++)for(var y1 = 0; y1 < 3; y1++){
                    if (this.state[y1][x1] === this.state[y1 + 1][x1]) return true;
                }
                return false;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$startButton = document.querySelector(".button--start");
var $197cd56b15c33885$var$helpButton = document.querySelector(".button--help");
var $197cd56b15c33885$var$gameScore = document.querySelector(".game-header__score-value");
var $197cd56b15c33885$var$fieldCells = document.querySelectorAll(".game-field__cell");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message--start");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message--win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message--lose");
var $197cd56b15c33885$var$modal = document.querySelector(".modal");
var $197cd56b15c33885$var$modalContent = document.querySelector(".modal__content");
var $197cd56b15c33885$var$closeModalBtn = document.querySelector(".modal__close");
var $197cd56b15c33885$var$modalCloseBtn = document.querySelector(".modal__button");
var $197cd56b15c33885$var$previousState = $197cd56b15c33885$var$game.getState();
function $197cd56b15c33885$var$updateUI() {
    var newState = $197cd56b15c33885$var$game.getState();
    newState.forEach(function(row, y) {
        row.forEach(function(value, x) {
            var cell = $197cd56b15c33885$var$fieldCells[y * 4 + x];
            var prevValue = $197cd56b15c33885$var$previousState[y][x];
            cell.textContent = value || "";
            cell.className = "game-field__cell";
            if (value) cell.classList.add("game-field__cell--".concat(value));
            if (value !== prevValue) {
                cell.classList.add("game-field__cell--appear");
                setTimeout(function() {
                    cell.classList.remove("game-field__cell--appear");
                }, 150);
            }
        });
    });
    $197cd56b15c33885$var$previousState = newState.map(function(row) {
        return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
    });
    $197cd56b15c33885$var$gameScore.textContent = $197cd56b15c33885$var$game.getScore();
    $197cd56b15c33885$var$messageStart.classList.toggle("hidden", $197cd56b15c33885$var$game.getStatus() !== "idle");
    $197cd56b15c33885$var$messageWin.classList.toggle("hidden", $197cd56b15c33885$var$game.getStatus() !== "win");
    $197cd56b15c33885$var$messageLose.classList.toggle("hidden", $197cd56b15c33885$var$game.getStatus() !== "lose");
    $197cd56b15c33885$var$startButton.textContent = $197cd56b15c33885$var$game.getStatus() === "idle" ? "Start" : "Restart";
    $197cd56b15c33885$var$startButton.classList.toggle("button--start", $197cd56b15c33885$var$game.getStatus() === "idle");
    $197cd56b15c33885$var$startButton.classList.toggle("button--restart", $197cd56b15c33885$var$game.getStatus() !== "idle");
}
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") $197cd56b15c33885$var$game.start();
    else $197cd56b15c33885$var$game.restart();
    $197cd56b15c33885$var$updateUI();
});
function $197cd56b15c33885$var$openModal() {
    $197cd56b15c33885$var$modal.classList.remove("modal--hidden");
    document.body.style.overflow = "hidden";
    if ($197cd56b15c33885$var$modalContent) $197cd56b15c33885$var$modalContent.scrollTop = 0;
}
function $197cd56b15c33885$var$closeModal() {
    $197cd56b15c33885$var$modal.classList.add("modal--hidden");
    document.body.style.overflow = "";
}
$197cd56b15c33885$var$helpButton.addEventListener("click", $197cd56b15c33885$var$openModal);
$197cd56b15c33885$var$closeModalBtn.addEventListener("click", $197cd56b15c33885$var$closeModal);
$197cd56b15c33885$var$modalCloseBtn.addEventListener("click", $197cd56b15c33885$var$closeModal);
window.addEventListener("click", function(e) {
    if (e.target === $197cd56b15c33885$var$modal) $197cd56b15c33885$var$closeModal();
});
document.addEventListener("keydown", function(e) {
    if (e.key === "Escape" && !$197cd56b15c33885$var$modal.classList.contains("modal--hidden")) {
        $197cd56b15c33885$var$closeModal();
        return;
    }
    if (!$197cd56b15c33885$var$modal.classList.contains("modal--hidden") || $197cd56b15c33885$var$game.getStatus() !== "playing") return;
    switch(e.key){
        case "ArrowLeft":
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    $197cd56b15c33885$var$updateUI();
});
$197cd56b15c33885$var$updateUI();

})();
//# sourceMappingURL=index.2e551d85.js.map
